import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";
import { commonServices } from "../../services";
import { startLoader, stopLoader } from "../actions";
import * as actionTypes from "../actionTypes";

function* getLatLngFromAddrs(action) {
  yield put(startLoader());
  console.log("getLatLngFromAddrs");
  
  try {
    const response = yield call(commonServices.getLatLngFromAddrs, action?.query);
    const { data } = response;
    console.log(data);
    
    yield put(stopLoader());
    
    if (data?.found) {
      yield put({
        type: actionTypes.GEOCOADING_SUCCEEDED,
        payload: {
          availableLocations: data,
          error: false,
        },
      });

      yield put({
        type: actionTypes.SET_SHOW_MAP,
        payload: {
          displayMap: true,
        },
      });
    } else {
      const errorMessage = data?.message || "Please provide valid address.";
      toast.error(errorMessage);
      yield put({
        type: actionTypes.GEOCOADING_FAILED,
        payload: { error: true, message: errorMessage },
      });
    }
  } catch (error) {
    yield put(stopLoader());
    console.error("Geocoding saga error:", error);
    
    const errorMessage = error?.message || "Failed to fetch location data. Please try again.";
    toast.error(errorMessage);
    
    yield put({
      type: actionTypes.GEOCOADING_FAILED,
      payload: { error: true, message: errorMessage },
    });
  }
}

function* commonSaga() {
  yield takeLatest(actionTypes.GEOCOADING_REQUESTED, getLatLngFromAddrs);
}

export default commonSaga;
